/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { generateDocsUrl } from '../../../ia/util/docs';

export const links = {
  intelepeerAccountLink: 'https://atmosphere.intelepeer.com/home',
  twilioAccountLink: 'https://www.twilio.com/login',
  genesysAccountLink:
    'https://github.ibm.com/watson-engagement-advisor/haa-integration/wiki/Creating-the-Genesys-BotConnector-Integration',
  genesysAPILink: 'https://developer.genesys.cloud/platform/api/',
  learnMoreDeployPhoneLink: generateDocsUrl('/?topic=assistant-deploy-phone'),
  learnMoreDeployPhoneNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-phone'
  ),
  learnMoreDeploySmsLink: generateDocsUrl('/?topic=assistant-deploy-sms'),
  learnMoreDeploySmsNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-sms'
  ),
  learnMoreAdvancedOptions: generateDocsUrl(
    '/?topic=assistant-deploy-sms#deploy-sms-advanced'
  ),
  learnMoreAdvancedOptionsNewIA: generateDocsUrl(
    '/?topic=watson-assistant-deploy-sms#deploy-sms-advanced'
  )
};
